import React, { useRef } from 'react'
import { Route, Switch, useRouteMatch } from 'react-router'
import { ExternalStorageHome, ExternalStoragePage } from '.'
import type { ExternalStorageSideMenuRef } from '../../components/ExternalStorage'
import { ExternalStorageSideMenu } from '../../components/ExternalStorage'
import { BaseLayout } from '../../layouts'

const ExternalStorageRouter = (): React.ReactElement => {
  const { path } = useRouteMatch()
  const sideMenuRef = useRef<ExternalStorageSideMenuRef>(null)

  return (
    <BaseLayout menu={<ExternalStorageSideMenu ref={sideMenuRef} />}>
      <Switch>
        <Route path={`${path}`} component={ExternalStorageHome} exact />
        <Route path={`${path}/:sourceId`} exact>
          <ExternalStoragePage sideMenuRef={sideMenuRef} />
        </Route>
      </Switch>
    </BaseLayout>
  )
}

export default ExternalStorageRouter
